<template>
	<!-- Amount&duration -->
	<div v-if="amount_view" class="text-color-text font-semibold text-3xl rounded-lg flex items-center mt-4">
		<div class="w-full grid grid-flow-col justify-items-center gap-4">
			<!-- Amount -->
				<div class="grid  grid-flow-row lg:grid-flow-col lg:grid-cols-3 justify-items-center">
					<div class=''>{{ $t('eny.amount') }}</div>
					<div class='lg:col-span-2'>{{ $t('eny.chf') }} {{ amount_view }}</div>
				</div>
			<!-- Duration -->
			<div class="grid grid-flow-row lg:grid-flow-col lg:grid-cols-3 justify-items-center">
				<div class=''>{{ $t('eny.duration') }}</div>
				<div class='lg:col-span-2'>{{ duration }} {{$t('eny.months')}}</div>
			</div>
		</div>
	</div>
	<!-- Rate -->
	<div class="text-3xl pt-7 text-center font-cooper">{{$t('eny.monthly_rate_in_CHF')}}</div>
	<div class="pt-2 flex flex-row gap-2 xs:gap-0">
		<!-- Calculation 5.9% size lg -->
		<div class="hidden w-1/2 md2:flex flex-col items-center">
			<div class="text-base text-center">{{$t('eny.calc_example_w_annual_interest', {interest: min_interest})}}*</div>
			<div class="bg-color-2 text-white font-bold text-lg rounded-full flex items-center mt-2 w-44">
				<div class="px-4 py-1 text-3xl w-full text-center">{{month_rent_min}}</div>
			</div>
			<div v-show="incl_insurance" class="flex flex-row px-4 py-1 w-72 justify-between">
				<div>{{$t('eny.insurance_part')}}:</div>
				<div>{{rate_insurance_min}}</div>
			</div>
			<div class="flex flex-row px-4 py-1 w-72 justify-between">
				<div>{{$t('eny.total_interest_cost')}}:</div>
				<div>{{total_interest_cost__min}}</div>
			</div>
		</div>
		<!-- Calculation {min_interest}% size small -->
		<div class="md2:hidden w-1/2 flex flex-col items-center">
			<div class="text-base text-center">{{ min_interest }}% {{$t('eny.annual_interest')}}*</div>
			<div class="bg-color-2 text-white font-bold text-lg rounded-full flex items-center mt-2">
				<div class="px-4 py-1 text-3xl w-full text-center">{{month_rent_min}}</div>
			</div>
		</div>
		<!-- Calculation {max_interest}% size lg -->
		<div class="hidden w-1/2 md2:flex flex-col items-center">
			<div class="text-base text-center w-72">{{$t('eny.calc_example_w_annual_interest', {interest: max_interest})}}*</div>
			<div class="bg-color-2 text-white font-bold text-lg rounded-full flex items-center mt-2 w-44">
				<div class="px-4 py-1 text-3xl w-full text-center">{{month_rent_max}}</div>
			</div>
			<div v-show="incl_insurance" class="flex flex-row px-4 py-1 w-72 justify-between">
				<div>{{$t('eny.insurance_part')}}:</div>
				<div>{{rate_insurance_max}}</div>
			</div>
			<div class="flex flex-row px-4 py-1 w-72 justify-between">
				<div>{{$t('eny.total_interest_cost')}}:</div>
				<div>{{total_interest_cost__max}}</div>
			</div>
		</div>
		<!-- Calculation 11.95% size small -->
		<div class="md2:hidden w-1/2 flex flex-col items-center">
			<div class="text-base text-center">{{ max_interest }}% {{$t('eny.annual_interest')}}*</div>
			<div class="bg-color-2 text-white font-bold text-lg rounded-full flex items-center mt-2">
				<div class="px-4 py-1 text-3xl w-full text-center">{{month_rent_max}}</div>
			</div>
		</div>
	</div>
	<!-- Anteil size small -->
	<div class="flex md2:hidden flex-col px-4 pt-3 items-center">{{$t('eny.insurance_part')}}:</div>
	<div class="md2:hidden flex flex-row w-full pt-1">
		<div class="w-1/2 flex justify-center">
			<div class="rounded-full bg-color-5 text-center mx-4 w-full max-w-xs">{{rate_insurance_min}}</div>
		</div>
		<div class="w-1/2 flex justify-center">
			<div class="rounded-full bg-color-5 text-center mx-4 w-full max-w-xs">{{rate_insurance_max}}</div>
		</div>
	</div>
	<div class="md2:hidden flex flex-col items-center px-4 pt-1">{{$t('eny.total_interest_cost')}}:</div>
	<div class="md2:hidden flex flex-row w-full pt-1">
		<div class="w-1/2 flex justify-center">
			<div class="rounded-full bg-color-5 text-center mx-4 w-full max-w-xs">{{total_interest_cost__min}}</div>
		</div>
		<div class="w-1/2 flex justify-center">
			<div class="rounded-full bg-color-5 text-center mx-4 w-full max-w-xs">{{total_interest_cost__max}}</div>
		</div>
	</div>
	<slot></slot>
</template>
<script>
import useUtils from '../../hooks/useUtils';
import { mapActions, mapGetters } from "vuex";
export default {
	name: "Rate",
	props: ['duration', 'amount', 'amount_view', 'incl_insurance'],
	setup() {
		const { formatAmount } = useUtils();
		return {
			formatAmount,
		};
	},
	data() {
		return {
			// data variables
			month_rent_min: "",
			rate_insurance_min: "",
			total_interest_cost__min: "",
			month_rent_max: "",
			rate_insurance_max: "",
			total_interest_cost__max: "",
		};
	},
	computed: {
		...mapGetters('config', ['config']),
		min_interest() {
			return this.config.min_interest;
		},
		max_interest() {
			return this.config.max_interest;
		}
	},
	methods: {
		...mapActions('config', ['fetchConfig']),
		updateData: function() {
			const calculated_min = this.calculate(this.min_interest);
			this.month_rent_min = this.formatAmount(calculated_min.month_rent);
			this.rate_insurance_min = this.formatAmount(calculated_min.insurance);
			this.total_interest_cost__min = this.formatAmount(calculated_min.total_interest_cost);
			const calculated_max = this.calculate(this.max_interest);
			this.month_rent_max = this.formatAmount(calculated_max.month_rent);
			this.rate_insurance_max = this.formatAmount(calculated_max.insurance);
			this.total_interest_cost__max = this.formatAmount(calculated_max.total_interest_cost);
		},
		calculate: function(effective_interest_rate_procent) {
			const effective_interest_rate = effective_interest_rate_procent / 100;
			// = ( ( 1 + Effektiver Zinssatz) ^ (1/12) - 1) x 12
			const nominal_interest_rate = (Math.pow(1 + effective_interest_rate, 1/12) - 1) * 12;
			// = (Nettokreditsumme x Nominaler Zinssatz /12 ) / (1- (1+ Nominaler Zinssatz /12) ^ (- Laufzeit))"
			const month_rent = this.round((this.amount * nominal_interest_rate / 12) / (1 - Math.pow((1 + nominal_interest_rate / 12), -this.duration)));
			// = Monatliche Rate x Laufzeit - Nettokreditsumme
			const total_interest_cost = this.round(month_rent * this.duration - this.amount);
			// = Nettokreditbetrag + Gesamte Zinskosten
			//	const gross_loan_amount = this.round(this.amount + total_interest_cost);
			// = Restschuldversicherung (PPI) - monatliche Prämie = 7.5% von der monatlichen Rate
			const residual_debt_insurance_PPI__monthly_premium = this.round(month_rent * 0.075);
			// = Monatliche Rate + Restschuldversicherung
			const total_monthly_cost = this.round(month_rent + residual_debt_insurance_PPI__monthly_premium);
			return {month_rent: this.incl_insurance ? total_monthly_cost : month_rent, insurance: residual_debt_insurance_PPI__monthly_premium, total_interest_cost: total_interest_cost};
		},
		round: function(amount) {
			return Math.round(amount * 20) / 20;
		},
	},
	mounted() {
		this.fetchConfig().then(() => {
			this.updateData();
		});
	},
	watch: {
		duration() {
			this.updateData();
		},
		amount() {
			this.updateData();
		},
		incl_insurance() {
			this.updateData();
		}
	}
}
</script>
